import isNewMailToastEnabled from '../selectors/isNewMailToastEnabled';
import isNewMailSoundEnabled from '../selectors/isNewMailSoundEnabled';
import isReminderToastEnabled from '../selectors/isReminderToastEnabled';
import isReminderSoundEnabled from '../selectors/isReminderSoundEnabled';
import { getUserConfiguration } from 'owa-session-store';
export default function isAppNotificationsOptionDirty() {
    var userOptions = getUserConfiguration().UserOptions;
    var newMailSoundEnabledInUserOptions = !!(userOptions.NewItemNotify & 1 /* Sound */);
    var newMailToastEnabledInUserOptions = !!(userOptions.NewItemNotify & 2 /* EMailToast */);
    return (newMailSoundEnabledInUserOptions !== isNewMailSoundEnabled() ||
        newMailToastEnabledInUserOptions !== isNewMailToastEnabled() ||
        userOptions.EnableReminderSound !== isReminderSoundEnabled() ||
        userOptions.EnableReminders !== isReminderToastEnabled());
}
//# sourceMappingURL=isAppNotificationsOptionDirty.js.map